import type { ReactNode } from "react";
import { useSession } from "../lib/auth-client.js";
import { LoginScreen } from "../pages/auth/LoginScreen.js";

/**
 * Renders children only when there's a valid session; otherwise shows the
 * Google login gate. While the session is being resolved, a minimal splash
 * avoids a flash of the login screen for already-signed-in users.
 */
export function AuthGate({ children }: { children: ReactNode }) {
  const { data, isPending } = useSession();

  if (isPending) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-canvas">
        <div className="h-6 w-6 animate-spin rounded-full border-2 border-line border-t-brand" />
      </div>
    );
  }

  if (!data?.session) return <LoginScreen />;

  return <>{children}</>;
}
